import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section background="white" data-id="element-193">
      <div className="space-y-8" data-id="element-194">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-195">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900" data-id="element-196">
            Si últimamente sientes que hablar con tus papás es como caminar
            sobre vidrio...
          </h2>
          <p className="text-base text-stone-600" data-id="element-197">
            El de llamar a tu mamá o a tu papá con buena intención… y terminar
            igual: tensión, indirectas, o discusión.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-198">
          <div className="bg-stone-50 p-6 rounded-2xl space-y-4 border border-stone-100" data-id="element-199">
            <ul className="space-y-3" data-id="element-200">
              {["Una frase tuya se vuelve 'falta de respeto'", 'Un pedido simple termina en crítica', 'Tú intentas arreglar, y ellos sienten que los estás corrigiendo', 'Al final, para evitar líos, te callas… pero te quedas cargado/a'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-201">
                  <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-orange-600 flex-shrink-0" data-id="element-202" />
                  <span className="text-stone-700 text-base leading-relaxed" data-id="element-203">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col justify-center space-y-4 p-4" data-id="element-204">
            <p className="text-stone-600 text-base italic" data-id="element-205">
              Y lo peor no es la pelea. Lo peor es lo que te queda después: esa
              culpa silenciosa de pensar{' '}
              <span className="font-medium text-stone-800" data-id="element-206">
                "pucha… capaz un día ya no están, y lo último que tuvimos fue
                esto."
              </span>
            </p>

            <div className="bg-orange-50 p-5 rounded-xl border-l-4 border-orange-600" data-id="element-207">
              <div className="flex gap-3" data-id="element-208">
                <AlertCircle className="w-5 h-5 text-orange-700 flex-shrink-0" data-id="element-209" />
                <p className="text-orange-900 font-medium text-sm" data-id="element-210">
                  Esto no se arregla con "paciencia" ni con "amor" solamente. Se
                  arregla con{' '}
                  <span className="font-bold underline decoration-orange-400 decoration-2 underline-offset-2" data-id="element-211">
                    código
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}